import React from "react";
import "./style.scss";

const Fieldset = (props) => {
  return (
    <fieldset className="form-fieldset">
      <legend>{props.title}</legend>
      {props.children}
    </fieldset>
  );
};

export default Fieldset;
